module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon_de-AT.2ca7f9e7.jpg";